class noteController {

  /* @ngInject */
  constructor (user, UsersService, $scope, $mdToast, $mdDialog, $mdMenu) {
    this.$scope = $scope
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog
    this.$mdMenu = $mdMenu

    this.UsersService = UsersService
    this.user = user

    this.message
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  addNote () {
    if (!this.message) {
      return
    }

    this.UsersService.addNote(this.user.id, this.message)
    this.$mdToast.showSimple('Note added')
    this.$mdDialog.cancel()
  }
}

export default noteController
